import mutations from './log.mutations'
import actions from './log.actions'
import getters from './log.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
